import defaultAuthorIcon from "@assets/user/default-author.svg";
import LinkIcon from "@elements/Icon/LinkIcon";
import { Link } from "react-router";
import { twMerge } from "tailwind-merge";

export type authorProps = {
  /**
   * URL of the author profile page.
   */
  destination: string;

  /**
   * URL of the author profile image.
   */
  authorSrc: string;

  /**
   * Additional CSS classes for the author icon.
   */
  iconClassName?: string;

  /**
   * Name of the author.
   */
  authorName: string;

  /**
   * Checks whether the article first-fold design is enabled.
   * @default false
   */
  isArticleFirstFoldEnabled?: boolean;
};

/**
 * Displays an author profile image and name with a link to their profile.
 */
export default function Author({
  destination,
  authorSrc,
  iconClassName,
  authorName,
  isArticleFirstFoldEnabled = false,
}: authorProps) {
  return (
    <>
      {destination && (
        <div
          className={twMerge(
            "inline-flex text-red-100 font-primary font-semibold h-13.5 mb-5 pr-1",
            isArticleFirstFoldEnabled && "mb-0 gap-2 items-center",
          )}
          data-testid="author-wrapper"
        >
          {authorSrc ? (
            <LinkIcon
              destination={destination}
              src={authorSrc}
              alt="author"
              height={isArticleFirstFoldEnabled ? "45px" : "50px"}
              width={isArticleFirstFoldEnabled ? "45px" : "50px"}
              className={twMerge(
                "p-1 mr-3.5 rounded-500",
                isArticleFirstFoldEnabled && "mr-0 p-0",
                iconClassName,
              )}
            />
          ) : isArticleFirstFoldEnabled ? (
            <LinkIcon
              destination={destination}
              src={defaultAuthorIcon}
              alt="author"
              height="50px"
              width="45px"
            />
          ) : (
            <div className="rounded-500" aria-hidden="true" />
          )}

          <Link
            to={destination}
            className={twMerge(
              "text-red-100 text-2sm hover:text-red-200 hover:underline place-content-center",
              isArticleFirstFoldEnabled && "w-36",
            )}
            aria-label={`ஆசிரியரின் பக்கம்: ${authorName}`}
          >
            {authorName} {!isArticleFirstFoldEnabled && " >"}
          </Link>
        </div>
      )}
    </>
  );
}
